import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-select-user-card',
  templateUrl: './select-user-card.component.html',
  styleUrls: ['./select-user-card.component.scss'],
})
export class SelectUserCardComponent implements OnInit {
  @Input() item: any;
  @Input() index: number;
  @Input() color: string;
  @Input() buttons: string;
  realIndex: number = 1;
  isLoading: boolean = false;

  constructor() { }

  ngOnInit() {
    this.realIndex = Number(this.index);
    var str: string = String(this.item.avatar);
    var n = str.search('www.gravatar.com');
    if (n > -1) {
      this.item.avatar = undefined;
    }
  }
}
